/**
 * wayai update — update CLI to the latest version
 */

import { execSync } from 'node:child_process';
import { captureException, closeSentry } from '../lib/sentry.js';

export async function updateCommand(pkg: { version: string }): Promise<void> {
  console.log(`Current version: ${pkg.version}`);
  console.log('Checking for updates...');
  try {
    // Shell `execSync` (fixed command string, no interpolation) resolves npm's `.cmd` shim on
    // Windows without the args-array + shell:true combination that triggers Node's DEP0190 warning.
    const latest = execSync('npm view @wayai/cli version', {
      timeout: 10000,
    }).toString().trim();
    if (latest === pkg.version) {
      console.log(`Already on the latest version (${pkg.version}).`);
    } else {
      console.log(`Updating ${pkg.version} → ${latest}...`);
      execSync('npm install -g @wayai/cli@latest', {
        timeout: 60000,
        stdio: 'inherit',
      });
      console.log(`Updated to ${latest}.`);
    }
  } catch (err) {
    captureException(err);
    await closeSentry();
    console.error('Update failed:', err instanceof Error ? err.message : String(err));
    console.error('Try manually: npm install -g @wayai/cli');
    process.exit(1);
  }
}
